import { SET_FUNDRAISER } from 'actions/types'

const initial = {}

export default (state = initial, action) => {
  switch (action.type) {
    case SET_FUNDRAISER:
      return {
        ...action.fundraiser,
      }
    default:
      return state
  }
}
